import { mount } from "@vue/test-utils";
import FormValidator from "@/components/core/FormValidator";

describe("FormValidator test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(FormValidator);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component FormValidator", () => {
    expect(wrapper).toBeDefined();
  });
});
